/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".overlay.listClients .ol-main .ol-content{height:calc(100% - 50px - env(safe-area-inset-top))}.overlay.listClients .ol-main .ol-content .ol-block .action span{color:#1ca8d9;font-size:14px;font-weight:700;border-bottom:0}.overlay.listClients .ol-main .ol-content .ol-apply{margin:10px 0 0}.overlay.listClients .ol-main .ol-content .ol-apply button{min-width:100px;height:40px;text-shadow:none;background-color:#0091d2;display:block;width:100%;margin:0 15px}"];
export { styles as styles };
